<template>
  <main class="relative">
    <div class="fixed h-screen w-screen inset-0 -z-10 overflow-hidden">
      <div
        class="fixed -top-40 -right-40 size-[520px] rounded-full bg-gradient-to-tr from-fuchsia-500/30 via-indigo-500/20 to-cyan-400/20 blur-3xl"
      ></div>
      <div
        class="fixed -bottom-40 -left-40 size-[520px] rounded-full bg-gradient-to-tr from-cyan-400/20 via-sky-500/20 to-violet-600/25 blur-3xl"
      ></div>
      <div
        class="fixed inset-0 bg-[radial-gradient(ellipse_at_top,rgba(255,255,255,0.08),transparent_60%)]"
      ></div>
      <div
        class="fixed inset-0 [mask-image:linear-gradient(to_bottom,black,transparent_85%)]"
      >
        <div
          class="mx-auto size-full max-w-6xl bg-[linear-gradient(0deg,transparent_24px,rgba(255,255,255,0.06)_24px),linear-gradient(90deg,transparent_24px,rgba(255,255,255,0.06)_24px)] [background-size:64px_64px] opacity-40"
        ></div>
      </div>
    </div>

    <section
      class="max-w-7xl mx-auto flex flex-col items-center py-24 sm:py-32 lg:py-40 relative px-4"
    >
      <div class="text-center">
        <p class="mb-6 text-xs font-medium uppercase tracking-wider">
          Wiedza na wyciągnięcie ręki
        </p>
        <h2
          class="mb-3 text-pretty text-3xl font-semibold md:mb-4 md:text-4xl lg:mb-6 lg:max-w-3xl lg:text-5xl"
        >
          Przydatne artykuły i porady
        </h2>
        <p class="mb-8 text-zinc-700 md:text-base lg:max-w-2xl lg:text-lg">
          Zgromadziliśmy tu najważniejsze informacje, które pomogą Ci lepiej zrozumieć
          świat marketingu cyfrowego i wykorzystać jego potencjał dla Twojej firmy.
        </p>
      </div>
      <div class="grid gap-6 md:grid-cols-2 lg:grid-cols-3 lg:gap-8">
        <NuxtLink
          v-for="article in data"
          :to="article.path"
          class="iq-card-solid p-4 flex flex-col group relative overflow-hidden rounded-2xl border border-white/10 bg-white/5 backdrop-blur transition duration-300 hover:-translate-y-1 hover:shadow-2xl hover:shadow-black/20 sm:p-8"
        >
          <div class="aspect-[16/9]">
            <FlexuilibMagicLottie
              class="h-full"
              :src="article.lottie"
              v-if="article.lottie"
            />

            <img
              v-else
              :src="article.image"
              :alt="article.title"
              class="h-full w-full object-cover object-center"
            />
          </div>
          <div class="mt-4">
            <h3 class="mb-3 text-lg font-semibold md:mb-4 md:text-xl lg:mb-6">
              {{ article.title }}
            </h3>
            <p class="mb-3 text-zinc-600 md:mb-4 lg:mb-6">
              {{ article.description }}
            </p>
          </div>
        </NuxtLink>
      </div>
    </section>
  </main>
</template>

<script setup>
const title = "Poradnik dla firm: strona www, marketing, Google | TurboWeb Wrocław";
const description =
  "Dowiedz się, jak tworzyć skuteczne strony i treści, działać w Google i przyciągać lokalnych klientów. Proste, konkretne porady dla początkujących przedsiębiorców z Wrocławia i okolic.";
useSeoMeta({ title, description });

const route = useRoute();
const { data } = await useAsyncData(route.path, () => {
  return queryCollection("pomoc").all();
});
</script>
